import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { hasPermission } from '../../helpers/jwt';
import navigationConfig from './MenuConfig';
import { AppInfo } from './AppInfo';

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      className={`position-fixed d-md-block d-none top-0 start-0 bg-white border-end d-flex flex-column ${
        collapsed ? 'p-2' : 'p-3'
      }`}
      style={{
        height: '100vh',
        width: collapsed ? '60px' : '285px',
        zIndex: 1020,
      }}
    >
      <Button
        variant="outline-secondary"
        size="sm"
        className="mb-3 ms-auto"
        onClick={() => setCollapsed(!collapsed)}
      >
        <i className="fas fa-bars" />
      </Button>

      <nav className="nav flex-column mt-3 ps-2">
        {navigationConfig
          .filter((item) => !item.permission || hasPermission(item.permission))
          .map(({ title, navigate, icon: Icon }) => (
            <NavLink
              key={title}
              to={navigate}
              className="nav-link d-flex align-items-center py-3 btn btn-light"
            >
              <Icon className="me-3" />
              {!collapsed && title}
            </NavLink>
          ))}
      </nav>

      {/* AppInfo fixed at the bottom center */}
      <div
        className="position-absolute bottom-0 start-50 translate-middle-x pb-3 text-center"
      >
        <AppInfo />
      </div>

    </div>
  );
};

export default Sidebar;
